import { Component, Input } from '@angular/core';
import { WarningImportLogItem } from '../../model/warning-import-log-item';

@Component({
    selector: 'redispatch-warning-importlogitem',
    templateUrl: './warning-import-log-item.component.html',
    styleUrls: [
        './warning-import-log-item.component.scss',
    ],
    standalone: false,
})
export class WarningImportLogItemComponent {

    @Input()
        warningImportLogItem: WarningImportLogItem;

    constructor() {
    }

}
